import { useLocale } from "@superweb/intl";
import { useFlag } from "@superweb/flags";

import { useV1ParkInfoGet } from "@fleet/api/fleet-forms";

import { useOperationIdContext } from "../ui";

import { searchParamTypes as t, useSearchParams } from "../router-new";
import { useParkInfoContext } from "../park-info-context";

export const useBrand = () => {
  const locale = useLocale();

  const { sessionId } = useOperationIdContext();

  const [{ ref_id }] = useSearchParams({
    ref_id: t.string,
  });

  const flag = useFlag();
  const enableParkInfoFromContext = flag({
    id: "f5a3b7d9-c2e4-4f16-8a9b-d0e1f2a3b4c5",
    description: "Enable park info from context",
  });

  const parkInfoFromContext = useParkInfoContext();

  const { data: parkInfoDeprecated } = useV1ParkInfoGet(
    {
      headers: {
        language: locale.toString(),
        "x-session-id": sessionId,
      },
      query: { ref_id: ref_id! },
    },
    {
      enabled: !enableParkInfoFromContext && Boolean(ref_id),
    },
  );

  if (enableParkInfoFromContext) {
    if (!parkInfoFromContext || parkInfoFromContext.status === 400) return "";

    return parkInfoFromContext.status === 200
      ? parkInfoFromContext.body.brand
      : parkInfoFromContext.body.park_info.brand;
  }

  return parkInfoDeprecated?.status !== 400
    ? parkInfoDeprecated?.data.brand
    : "";
};
